<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><img alt="image" src="images/title.png"/></h1>
<p class="sub-title">A True Story of Love, Change<br/><span class="bitalic">&amp;</span> an Old Tuscan Farmhouse</p>
<p class="author">VICTORIA SMITH</p>
<p class="publisheri"><img alt="image" src="images/pub.png"/></p>
<p class="publisher">NEW YORK</p>
<p class="publishers">LONDON • NASHVILLE • MELBOURNE • VANCOUVER</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?366b6bd4